// extracted by mini-css-extract-plugin
export default {"captcha":"FTuID","captchaInput":"hgnCO","bis":"eAhnR","imgBis":"i4P76","resetBis":"HRprk","inputBis":"kTv1y","reset":"eSGej","headerCaptcha":"hEUmk","loginPage":"csjCW"};